import { useState, useEffect, useCallback } from 'react';
import { db } from '../firebaseConfig'; 
import { collection, getDocs } from 'firebase/firestore';

export function useRulesData() {
  const [allRulesData, setAllRulesData] = useState([]);
  const [broadcasters, setBroadcasters] = useState([]);
  const [regulationTexts, setRegulationTexts] = useState([]); // NEW
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const [broadcastersSnapshot, textsSnapshot] = await Promise.all([
        getDocs(collection(db, "broadcasters")),
        getDocs(collection(db, "regulation_texts"))
      ]);

      const textMap = {};
      const textsList = []; // NEW: Collection for the dropdown
      
      textsSnapshot.forEach(doc => {
        const data = doc.data();
        if (data.text_id) {
            textMap[data.text_id] = data;
            textsList.push(data);
        }
      });

      // Sort alphabetically for the dropdown
      textsList.sort((a, b) => (a.text_name || '').localeCompare(b.text_name || ''));
      setRegulationTexts(textsList);

      const getUniqueRelevantTexts = (data) => {
        const uniqueValues = new Set();
        function traverse(node) {
          if (!node || typeof node !== 'object') return;
          if (node.hasOwnProperty('relevant_text') && node.relevant_text !== null) {
            uniqueValues.add(node.relevant_text);
          }
          Object.values(node).forEach(child => traverse(child));
        }
        traverse(data);
        return Array.from(uniqueValues);
      };

      const injectFamilyAndIds = (rulesObj) => {
        if (!rulesObj) return {};
        const families = {
          financingObligations: "Obligations de financement",
          chronoWindows: "Chronologie des médias",
          broadcastObligations: "Obligations de diffusion"
        };
        
        const newRules = { ...rulesObj };
        
        Object.keys(families).forEach(categoryKey => {
          if (Array.isArray(newRules[categoryKey])) {
            newRules[categoryKey] = newRules[categoryKey].map((rule, index) => ({
              ...rule,
              family: families[categoryKey],
              id: rule.id !== undefined && rule.id !== null 
                  ? rule.id 
                  : `generated-${Date.now()}-${index}-${Math.floor(Math.random() * 1000)}`
            }));
          }
        });
        return newRules;
      };

      const joinedData = broadcastersSnapshot.docs.map(doc => {
        const bData = doc.data();
        bData.firestoreId = doc.id; 
        
        if (bData.rules) {
            bData.rules = injectFamilyAndIds(bData.rules);
        }

        const refIds = getUniqueRelevantTexts(bData);
        const resolvedTexts = refIds.map(id => textMap[id]).filter(Boolean);
        
        return { ...bData, regulation_texts: resolvedTexts };
      });

      setAllRulesData(joinedData);

      const uniqueBroadcasters = joinedData.map(b => ({
        broadcaster_id: b.broadcaster_id,
        broadcaster_name: b.broadcaster_name,
      }));

      const uniqueMap = new Map();
      uniqueBroadcasters.forEach(b => uniqueMap.set(b.broadcaster_id, b));
      const distinctBroadcasters = Array.from(uniqueMap.values()).sort((a, b) => 
        a.broadcaster_name.localeCompare(b.broadcaster_name)
      );

      setBroadcasters(distinctBroadcasters);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { allRulesData, broadcasters, regulationTexts, loading, error, refreshData: fetchData }; // Return regulationTexts
}